import { UnicodeEntity } from '@mews/enums';

const Parenthesized: React.FC<React.PropsWithChildren<{}>> = ({ children }) => (
    <>
        {UnicodeEntity.LeftParenthesis}
        {children}
        {UnicodeEntity.RightParenthesis}
    </>
);

export default Parenthesized;
